import plugin from 'tailwindcss/plugin';

const itemSlide = plugin.withOptions(function () {
	return function ({ addComponents, theme, e }) {
		addComponents({
			[`.${e('item-slide')}`]: {
				borderRadius: `var(--item-slider-item-image-border-radius, ${theme('borderRadius.none')})`,
			},
			[`.${e('item-slide-overline')}`]: {
				fontWeight: `var(--heading-group-section-font-weight, ${theme('fontWeight.semibold')})`,
			},
		});
	};
});

export default itemSlide;
